import React from 'react'

import { CalendarBlank, MapPin } from '@phosphor-icons/react'
import { Column, Row, Text } from 'Components/UI'
import { DateTime } from 'luxon'
import { EventItem } from 'Types/emajinAPI'

import { Container, ImagePlaceholder } from './styles'

type Props = {
  data?: EventItem
}

function EventCard({ data }: Props) {
  if (!data) return null

  return (
    <Container>
      <Text mb={4} medium screen16>
        {data.location}: {data.venueName}
      </Text>

      <Text mb={5} regular screen14>
        {data.address}
      </Text>

      {data.attachments?.length ? (
        <img alt="" src={data.attachments[0].url} />
      ) : (
        <ImagePlaceholder />
      )}

      <Column fullWidth gap={4} grow mt={5} spaceBetween>
        <Column fullWidth gap={3} spaceBetween>
          <Row alignCenter gap={3}>
            <CalendarBlank size={16} weight="bold" />

            <Text bold fontSize={12} important uppercase>
              Dates
            </Text>
          </Row>

          <Row gap={2} pl={7}>
            <Text important medium screen14>
              Start:
            </Text>

            <Text body regular screen14>
              {DateTime.fromISO(data.createdAt).toFormat('MMM dd, yyyy')}
            </Text>
          </Row>
        </Column>

        <Column>
          <Row alignCenter gap={3}>
            <MapPin size={16} weight="bold" />

            <Text accent bold fontSize={12} uppercase>
              {data.location}
            </Text>
          </Row>

          <Row pl={7}>
            <Text body regular screen14>
              {data.venueName}
            </Text>
          </Row>
        </Column>
      </Column>
    </Container>
  )
}

export default EventCard
